/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Add } from '../../assets/themes/OPL/img/icons/Add.svg';

function AddButton({ ...props }) {
    const { classes, callback, callbackParam, color, text, tooltipTitle, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={Add}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
            tooltipTitle={tooltipTitle}
        />
    );
}

AddButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default AddButton;
